export default defineNuxtPlugin(() => {
  addRouteMiddleware(
    'shop-disabled',
    (to) => {
      // Shop is disabled - redirect /shop, /shop/*, and /checkout to home
      if (to.path === '/shop' || to.path.startsWith('/shop/') || to.path === '/checkout') {
        return navigateTo('/');
      }
    },
    { global: true }
  );
});
